import { useProductHead } from '~/scopes/product-core/components/ProductDetailPageBase/composables/useSeo/composables/useProductHead/useProductHead'
import { useFetchPickers } from '~/scopes/product-core/composables/useFetch/useFetchPickers/useFetchPickers'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'
import { useFetchReviews } from '~/scopes/product-core/composables/useFetch/useFetchReviews/useFetchReviews'
import { useFetchReviewsSummary } from '~/scopes/product-core/composables/useFetch/useFetchReviewsSummary/useFetchReviewsSummary'
import { useFetchTechnicalSpecifications } from '~/scopes/product-core/composables/useFetch/useFetchTechnicalSpecifications/useFetchTechnicalSpecifications'

export function useSeo() {
  const { data: productResponse } = useFetchProduct()
  const { selectedOffer, isOutOfStock } = useFetchPickers()
  const { data: reviewSummaryResponse } = useFetchReviewsSummary()
  const { data: technicalSpecificationsResponse } =
    useFetchTechnicalSpecifications()
  const { data: reviewsResponse } = useFetchReviews()

  useProductHead(
    productResponse,
    selectedOffer,
    reviewSummaryResponse,
    reviewsResponse,
    technicalSpecificationsResponse,
    isOutOfStock,
  )
}
